import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-50">星空影院</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              高清视频超清画质4K影视在线播放平台。蓝光画质无广告观影，热门电影电视剧不缓冲流畅看，免费追剧体验升级。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/action" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">动作片</Link>
              <Link to="/category/comedy" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">喜剧片</Link>
              <Link to="/category/scifi" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">科幻片</Link>
              <Link to="/category/drama" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">剧情片</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">画质分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">4K超清影视</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">蓝光1080P</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">高清720P</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">HDR影视专区</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">品牌介绍</Link>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">用户口碑</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">联系我们</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2024 星空影院 xingkongyingyuan.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/50 text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/50 text-foreground-500 hover:text-primary-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/50 text-foreground-500 hover:text-primary-500 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}